<template>
  <section class="py-4">
    <div class="row">
      <div class="col-md-12">
        <!-- Tab Navigation -->
        <div class="card mb-4">
          <div class="card-header p-0">
            <ul class="nav nav-tabs card-header-tabs" id="auditTabs" role="tablist">
              <li class="nav-item" role="presentation">
                <a 
                  class="nav-link" 
                  :class="{ active: activeTab === 'new-audit' }"
                  @click="switchTab('new-audit')"
                  href="#"
                  role="tab"
                >
                  <i class="fa fa-plus mr-2"></i>
                  New Audit
                </a>
              </li>
              <li class="nav-item" role="presentation">
                <a 
                  class="nav-link" 
                  :class="{ active: activeTab === 'previous-reports' }"
                  @click="switchTab('previous-reports')"
                  href="#"
                  role="tab"
                >
                  <i class="fa fa-history mr-2"></i>
                  Previous Reports
                </a>
              </li>
            </ul>
          </div>
          
          <div class="card-body">
            <!-- New Audit Tab Content -->
            <div v-if="activeTab === 'new-audit'" class="tab-content">
              <form @submit.prevent="submitAudit">
                <div class="mb-3">
                  <input
                      v-model="urlInput"
                      placeholder="Enter Domain Name"
                      class="form-control"
                  />
                </div>

                <div class="custom-control custom-checkbox">
                  <input type="checkbox" v-model="adblockChecked" class="custom-control-input" id="AdBlock"/>
                  <label class="custom-control-label pt-3" for="AdBlock">Enable AdBlock</label>
                </div>
                
                <button
                    class="btn btn-primary"
                    type="submit"
                    :disabled="loading"
                >
                  <span v-if="loading" class="fa fa-spinner fa-spin"></span>
                  <span v-else>Run Audit</span>
                </button>
              </form>
            </div>

            <!-- Previous Reports Tab Content -->
            <div v-if="activeTab === 'previous-reports'" class="tab-content">
              <!-- Search Input -->
              <div class="mb-4">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                      <i class="fa fa-search"></i>
                    </span>
                  </div>
                  <input
                    v-model="searchTerm"
                    @input="onSearchInput"
                    type="text"
                    class="form-control"
                    placeholder="Search by domain name..."
                  />
<!--                  <div class="input-group-append" v-if="searchTerm">-->
<!--                    <button -->
<!--                      class="btn btn-outline-secondary" -->
<!--                      type="button"-->
<!--                      @click="clearSearch"-->
<!--                    >-->
<!--                      <i class="fa fa-times"></i>-->
<!--                    </button>-->
<!--                  </div>-->
                </div>
              </div>

              <div v-if="loadingReports || isSearching" class="text-center py-4">
                <span class="fa fa-spinner fa-spin"></span>
                <span class="ml-2">{{ isSearching ? 'Searching...' : 'Loading reports...' }}</span>
              </div>
              <div v-else-if="filteredReports.length === 0 && !searchTerm" class="text-center py-4 text-muted">
                <i class="fa fa-inbox fa-3x mb-3 d-block"></i>
                <p>No previous reports found.</p>
                <button class="btn btn-primary" @click="switchTab('new-audit')">
                  <i class="fa fa-plus mr-2"></i>
                  Create Your First Report
                </button>
              </div>
              <div v-else-if="filteredReports.length === 0 && searchTerm" class="text-center py-4 text-muted">
                <i class="fa fa-search fa-3x mb-3 d-block"></i>
                <p>No reports found for "{{ searchTerm }}"</p>
                <button class="btn btn-outline-primary" @click="clearSearch">
                  <i class="fa fa-times mr-2"></i>
                  Clear Search
                </button>
              </div>
              <div v-else class="reports-list" style="max-height: 500px; overflow-y: auto;">
                <div v-if="searchTerm" class="mb-3">
                  <small class="text-muted">
                    <i class="fa fa-info-circle mr-1"></i>
                    Showing {{ filteredReports.length }} result(s) for "{{ searchTerm }}"
                  </small>
                </div>
                <div 
                  v-for="report in filteredReports" 
                  :key="report.id"
                  class="report-item border rounded p-3 mb-3 cursor-pointer"
                  @click="loadReport(report)"
                >
                  <div class="d-flex justify-content-between align-items-start">
                    <div>
                      <b class="mb-1">{{ report.siteUrl || report.domain }}</b><br>
                      <small class="text-muted">
                        <i class="fa fa-calendar mr-1"></i>
                        {{ report.createdAt }}
                      </small>
                      <br>
                      <small class="text-muted">
                        <i class="fa fa-user mr-1"></i>
                        {{ report.addedBy }}
                      </small>
                    </div>
                    <div class="text-right">
                      <button 
                        class="btn btn-sm btn-outline-primary"
                        @click.stop="loadReport(report)"
                      >
                        View Report
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!loading && (parsedReport.length || gtmetrixData || wpoDomain)" id="reportContent">
      <div class="row">
        <div class="col-md-12">
          <hr class="my-10"/>
          <div class="mb-4">
            <div>
              <button class="btn  btn-brand shadow download-pdf-btn d-flex align-items-center px-3  py-2 mr-3 mb-5" @click="downloadPdf">
              <span class="pdf-icon-wrapper d-flex align-items-center justify-content-center mr-2">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="24" height="24" rx="6" fill="#fff"/>
                  <path d="M6 2C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V8.82843C20 8.29799 19.7893 7.78929 19.4142 7.41421L15.5858 3.58579C15.2107 3.21071 14.702 3 14.1716 3H6ZM13 3.5V8C13 8.55228 13.4477 9 14 9H18.5L13 3.5Z" fill="#1f4bf1"/>
                  <path d="M9 15H15V17H9V15Z" fill="#1f4bf1"/>
                </svg>
              </span>
                <span class="font-weight-bold" style="">Download Report as PDF</span>
          </button>
            </div><br>
            <div class="share-link-card card border-0 shadow-sm mb-0 flex-grow-1" style="min-width: 260px;">
              <div class="card-body d-flex flex-column flex-md-row align-items-md-center p-3">
              <div class="share-link-icon d-flex align-items-center justify-content-center mr-md-4 mb-3 mb-md-0">
                <i class="fa fa-link"></i>
              </div>
              <div class="flex-grow-1">
                <label class="font-weight-bold mb-2" style="color: #1f4bf1;">Shareable Link:</label>
                <a href="javascript:void(0)" @click.prevent="copyLink"><i class="fa fa-copy pull-right"></i></a>
                <div class="input-group mb-2">
                  <input
                      type="text"
                      class="form-control border-0 bg-light"
                      :value="generatedLink"
                      readonly
                        style="font-size: 1.05rem; color: #1f4bf1; font-weight: 500; background: #f5f8ff; border-radius: 6px;"
                  />
                </div>
                <small class="form-text" style="color: #6c757d;">
                  Share this link to allow others to view this performance report.
                </small>
              </div>
            </div>
          </div>
          </div>
          <hr class="my-10"/>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 p-0">
          <section class="p-0 m-0" id="reportContent" style=" margin: auto;">

            <div class="main-page">

              <div class="p-3 ">
                <!-- Header Section -->
                <header class="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center mb-20  border-bottom" style=" padding-bottom: 1rem;">
                  <img src="https://www.bigscoots.com/wp-content/uploads/2022/10/bigscoots-logo-dark.svg" alt="BigScoots Logo" class="img-fluid" style="height: 40px;">
                  <div class="text-sm-right">
                    <h3 class=" m-0 font-weight-bold">Website Performance Audit</h3>
                  </div>
                </header>

                <!-- Report Details Section -->
                <div class="card-section p-4 mb-5">
                  <h4 class=" font-weight-bold mb-3">Report Overview</h4>
                  <div class="row">
                    <div class="col-12  d-flex align-items-center mb-3">
                      <svg xmlns="http://www.w3.org/2000/svg" class=" mr-5 text-secondary" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" /></svg>
                      <span class="font-weight-medium text-secondary-600 mr-5">URL Tested:</span>
                      <a :href="siteUrl" target="_blank" class="text-primary">{{ siteUrl }}</a>
                    </div>
                    <div class="col-12 col-md-6 d-flex align-items-center mt-10">
                      <svg xmlns="http://www.w3.org/2000/svg" class="bi mr-5 text-secondary" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg>
                      <span class="font-weight-medium text-secondary-600 mr-5">Prepared by:</span>
                      <img  :src="`https://www.gravatar.com/avatar/${displayAuthorEmailHash}?s=24`"   :alt="`${displayAuthor} avatar`" class="rounded-circle mr-5" style="width: 24px; height: 24px;">
                      <span>{{ displayAuthor }}</span>
                    </div>
                    <div class="col-12 col-md-6 d-flex align-items-center mb-3 mt-10">
                      <svg xmlns="http://www.w3.org/2000/svg" class="bi mr-5 text-secondary" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" /></svg>
                      <span class="font-weight-medium text-secondary-600 mr-5">Report Date:</span>
                      <span id="report-date">{{ displayReportDate }}</span>
                    </div>
                  </div>

                  <!-- Tests and Analysis Section -->
                  <div class="mt-10 pt-10 border-top">
                    <h5 class=" font-weight-medium mb-2">Tests & Analysis Conducted</h5>
                    <ul class="row">
                      <li class="col-12 col-sm-6 d-flex align-items-center mb-2">
                        <svg v-if="parsedReport.length" class="bi mr-5 text-success" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" /></svg>
                        <span v-else>
                        <i class="fa fa-warning text-warning mr-5" style="width: 20px; height: 20px"></i>
                      </span>
                        Field Performance Metrics (Core Web Vitals)
                      </li>
                      <li class="col-12 col-sm-6 d-flex align-items-center mb-2">
                        <svg v-if="gtmetrixData" class="bi mr-5 text-success" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" /></svg>
                        <span v-else>
                        <i class="fa fa-warning text-warning mr-5" style="width: 20px; height: 20px"></i>
                      </span>
                        Lab Performance Metrics (GTmetrix)
                      </li>
                      <li class="col-12 col-sm-6 d-flex align-items-center mb-2">
                        <svg v-if="wpoData && wpoData.success && wpoData.wpo_data && wpoData.wpo_data.domains && wpoData.wpo_data.domains.length" class="bi mr-5 text-success" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" /></svg>
                        <span v-else>
                        <i class="fa fa-warning text-warning mr-5" style="width: 20px; height: 20px"></i>
                      </span>
                        WordPress Core & Environment
                      </li>
                      <li class="col-12 col-sm-6 d-flex align-items-center mb-2">
                        <svg v-if="wpoData && wpoData.success && wpoData.wpo_data && wpoData.wpo_data.domains && wpoData.wpo_data.domains.length && wpoData.wpo_data.domains[0].plugins && wpoData.wpo_data.domains[0].plugins.length" class="bi mr-5 text-success" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" /></svg>
                        <span v-else>
                        <i class="fa fa-warning text-warning mr-5" style="width: 20px; height: 20px"></i>
                      </span>
                        WordPress Plugins
                      </li>
                      <li class="col-12 col-sm-6 d-flex align-items-center mb-2">
                        <svg v-if="wpoData && wpoData.success && wpoData.wpo_data && wpoData.wpo_data.domains && wpoData.wpo_data.domains.length && wpoData.wpo_data.domains[0].themes && wpoData.wpo_data.domains[0].themes.length" class="bi mr-5 text-success" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" /></svg>
                        <span v-else>
                        <i class="fa fa-warning text-warning mr-5" style="width: 20px; height: 20px"></i>
                      </span>
                        WordPress Themes
                      </li>
                      <li class="col-12 col-sm-6 d-flex align-items-center mb-2">
                        <svg v-if="wpoData && wpoData.success && wpoData.wpo_data && wpoData.wpo_data.domains && wpoData.wpo_data.domains.length && wpoData.wpo_data.domains[0].plugins && wpoData.wpo_data.domains[0].plugins.length" class="bi mr-5 text-success" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" /></svg>
                        <span v-else>
                        <i class="fa fa-warning text-warning mr-5" style="width: 20px; height: 20px"></i>
                      </span>
                        Security Vulnerability Checks
                      </li>
                    </ul>
                  </div>

                </div>

                <!-- Key Findings & Recommendations Section -->
                <div class="card-section px-4 mb-5" :class="!uodatedKeyFindings ? 'no-print' : ''">
                  <button data-toggle="modal"  @click="fixModal" data-target="#newKeyFindingsModal" class="btn btn-outline-primary pull-right no-print"><i class="fa fa-bullhorn"></i> Add / Update Findings</button>

                  <h3 class="h4 font-weight-medium mb-3">Key Findings & Recommendations</h3>

                  <div class="text-secondary" v-html="uodatedKeyFindings" />
                </div>

                <!-- How to Understand This Report Section -->
                <div class="pdf-break-before card-section px-4 mb-5">
                  <h2 class="h4 font-weight-semibold mb-3">How to Understand This Report</h2>
                  <div class="text-secondary">
                    <p>These first few pages provide a high-level overview of the audit findings. For a deeper dive into specific data points, detailed analysis, and our full recommendations, please use the "View More Details" button located within each section. This will take you to the relevant page with more comprehensive information.</p>
                  </div>
                </div>
                <div class="card-section px-4 mb-2" v-if="parsedReport.length">
                  <div class="d-flex justify-content-between align-items-center mb-2">
                    <h2 class="h4 font-weight-semibold d-flex align-items-center">Field Performance Metrics (Core Web Vitals)</h2>
                    <button
                        class="btn btn-sm text-dark btn-light border"
                        @click="smoothScrollTo('crux', 100)"
                        type="button"
                    >
                      View More Details
                    </button>
                  </div>
                  <p class="text-secondary">
                    This data is from the Chrome User Experience Report (CrUX) and reflects real performance from visitors across your entire website (origin-level data). It is the most accurate measure of your site's user experience.
                  </p>

                  <!-- Core Vitals Cards -->
                  <div class="row my-10">
                    <div
                        class="col-12 col-md-4 mb-4 mb-md-0"
                        v-for="metric in ['lcp', 'inp', 'cls']"
                        :key="metric"
                    >
                      <div class="border rounded p-3 h-100 d-flex flex-column text-center">
                        <div>
                          <div
                              class="metric-circle mx-auto mb-3"
                              :class="{
              'bg-green-100': getCruxBadge(metric).level === 'Good',
              'bg-yellow-100': getCruxBadge(metric).level === 'Needs Improvement',
              'bg-red-100': getCruxBadge(metric).level === 'Poor'
            }"
                          >
            <span
                class="display-5 font-weight-bold"
                :class="{
                'text-green-700': getCruxBadge(metric).level === 'Good',
                'text-yellow-700': getCruxBadge(metric).level === 'Needs Improvement',
                'text-red-700': getCruxBadge(metric).level === 'Poor'
              }"
            >
              {{ getCruxMetric(metric).p75 }}
            </span>
                          </div>
                          <h3 class="font-weight-bold h5 text-uppercase">{{ metric }}</h3>
                          <p class="small text-secondary">{{ getCruxMetric(metric).description }}</p>
                          <p class="text-xs text-secondary mt-1" v-html="getCruxMetric(metric).note">
                          </p>
                        </div>
                        <div class="mt-3">
          <span
              class="badge"
              :class="{
              'badge-success bg-green-100 text-green-700': getCruxBadge(metric).level === 'Good',
              'badge-warning bg-yellow-100 text-yellow-700': getCruxBadge(metric).level === 'Needs Improvement',
              'badge-danger bg-red-100 text-red-700': getCruxBadge(metric).level === 'Poor'
            }"
          >
            {{ getCruxBadge(metric).level }}
          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Additional Metrics -->
                  <div style="margin: 10px 0 10px 0">
                    <h3 class="h5 font-weight-semibold text-dark mb-3">Additional Metrics</h3>
                    <div class="d-flex justify-content-between align-items-center" >
                      <div
                          class="d-flex justify-content-between align-items-center bg-light p-3 rounded border mb-3"
                          v-if="getCruxMetric('ttfb')"
                          style="width: 49%; height: 100%"
                      >
                        <div>
                          <p class="font-weight-medium text-dark mb-1">Time to First Byte (TTFB)</p>
                          <p class="small text-muted mb-0">Measures server response time.</p>
                        </div>
                        <div class="text-right">
                          <p class="h5 font-weight-bold text-success mb-1">{{ getCruxMetric('ttfb').p75 }}</p>
                          <p class="small text-muted mb-0">Target: &lt; 0.8s</p>
                        </div>
                      </div>
                      <div
                          class="d-flex justify-content-between align-items-center bg-light p-3 rounded border"
                          v-if="getCruxMetric('fcp')"
                          style="width: 49%; height: 100%"
                      >
                        <div>
                          <p class="font-weight-medium text-dark mb-1">First Contentful Paint (FCP)</p>
                          <p class="small text-muted mb-0">Marks the first point in the page load timeline.</p>
                        </div>
                        <div class="text-right" style="width: 30%">
                          <p class="h5 font-weight-bold text-success mb-1">{{ getCruxMetric('fcp').p75 }}</p>
                          <p class="small text-muted mb-0">Target: &lt; 1.8s</p>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>

                <!-- Lab Performance Metrics (GTmetrix) Section -->
                <div class="pdf-break-before card-section p-4 mb-5 " v-if="gtmetrixData">
                  <div class="d-flex justify-content-between align-items-center mb-2">
                    <h2 class="h4 font-weight-semibold d-flex align-items-center">Lab Performance Metrics (GTmetrix)</h2>
                    <button
                        class="btn btn-sm text-dark btn-light border"
                        @click="smoothScrollTo('gtmetrix', 100)"
                        type="button"
                    >
                      View More Details
                    </button>
                  </div>
                  <p class=" text-secondary mb-4">
                    This is a lab test run by GTmetrix from a North American location on a simulated device. Lab data is excellent for diagnostics, but always reference Field Metrics for the most complete picture.
                  </p>
                  <div class="row print-only">
                    <div class="col-md-12">
                      <div class="bg-light border rounded p-4 mb-4 mb-md-0  d-flex flex-column flex-md-row align-items-center justify-content-between">
                        <div class="text-center mb-4 mb-md-0 mr-md-5"  style="width: 30%">
                          <span class="text-secondary small">Grade</span><br/>
                          <span class="display-3 mt-0 font-weight-bold" :class="gtmetrixData.performance_score > 90 ? 'text-success' : gtmetrixData.performance_score >= 80 ? 'text-warning' : 'text-danger'">
                        {{ computeGrade(gtmetrixData.performance_score) }}
                      </span>
                        </div>
                        <div class="d-flex flex-column flex-md-row align-items-center justify-content-between" style="width: 60%">
                          <div class="text-center mr-4">
                            <div class="progress-circle">
                              <svg viewBox="0 0 100 100">
                                <!-- Background circle -->
                                <circle class="text-light" stroke-width="10" stroke="currentColor" fill="transparent" r="45" cx="50" cy="50" />
                                <!-- Progress circle -->
                                <circle :class="gtmetrixData.performance_score > 90 ? 'text-success' : gtmetrixData.performance_score >= 80 ? 'text-warning' : 'text-danger'" stroke-width="10" stroke-linecap="round" stroke="currentColor" fill="transparent" r="45" cx="50" cy="50" />
                              </svg>
                              <span class="progress-text">{{ gtmetrixData.performance_score }}</span>
                            </div>
                            <p class="mt-2 font-weight-semibold">Performance</p>
                          </div>
                          <div class="text-center">
                            <div class="progress-circle">
                              <svg viewBox="0 0 100 100">
                                <circle class="text-light" stroke-width="10" stroke="currentColor" fill="transparent" r="45" cx="50" cy="50" />
                                <circle :class="gtmetrixData.structure_score > 90 ? 'text-success' : gtmetrixData.structure_score >= 80 ? 'text-warning' : 'text-danger'" stroke-width="10" stroke-linecap="round" stroke="currentColor" fill="transparent" r="45" cx="50" cy="50" />
                              </svg>
                              <span class="progress-text">{{ gtmetrixData.structure_score }}</span>
                            </div>
                            <p class="mt-2 font-weight-semibold">Structure</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12 h-100">
                      <div class="row h-100">
                        <div v-for="(value, label) in gtmetrixMetrics" :key="label" class="col-6 col-sm-3 mb-3 h-100">
                          <div class="bg-light p-1  rounded border text-center" >
                            <p class="text-xs text-secondary ">{{ label }}</p>
                            <p class="h4 m-0 font-weight-semibold text-success mb-0" style="font-size: 1.2rem;">{{ value }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="no-print d-flex flex-column flex-md-row">
                    <!-- Grade + Scores -->
                    <div class="bg-light border rounded p-4 mb-4 mb-md-0 mr-md-4 d-flex flex-column flex-md-row align-items-center justify-content-center">
                      <div class="text-center mb-4 mb-md-0 mr-md-5">
                        <span class="text-secondary small">Grade</span><br/>
                        <span class="display-4 mt-0 font-weight-bold " :class="gtmetrixData.performance_score > 90 ? 'text-success' : gtmetrixData.performance_score >= 80 ? 'text-warning' : 'text-danger'">
                        {{ computeGrade(gtmetrixData.performance_score) }}
                      </span>
                      </div>
                      <div class="d-flex">
                        <div class="text-center mr-4">
                          <div class="progress-circle">
                            <svg viewBox="0 0 100 100">
                              <!-- Background circle -->
                              <circle class="text-light" stroke-width="10" stroke="currentColor" fill="transparent" r="45" cx="50" cy="50" />
                              <!-- Progress circle -->
                              <circle :class="gtmetrixData.performance_score > 90 ? 'text-success' : gtmetrixData.performance_score >= 80 ? 'text-warning' : 'text-danger'" stroke-width="10" stroke-linecap="round" stroke="currentColor" fill="transparent" r="45" cx="50" cy="50" />
                            </svg>
                            <span>{{ gtmetrixData.performance_score }}</span>
                          </div>
                          <p class="mt-2 font-weight-semibold">Performance</p>
                        </div>
                        <div class="text-center">
                          <div class="progress-circle">
                            <svg viewBox="0 0 100 100">
                              <circle class="text-light" stroke-width="10" stroke="currentColor" fill="transparent" r="45" cx="50" cy="50" />
                              <circle :class="gtmetrixData.structure_score > 90 ? 'text-success' : gtmetrixData.structure_score >= 80 ? 'text-warning' : 'text-danger'" stroke-width="10" stroke-linecap="round" stroke="currentColor" fill="transparent" r="45" cx="50" cy="50" />
                            </svg>
                            <span>{{ gtmetrixData.structure_score }}</span>
                          </div>
                          <p class="mt-2 font-weight-semibold">Structure</p>
                        </div>
                      </div>
                    </div>

                    <!-- Metrics Grid -->
                    <div class="row">
                      <div v-for="(value, label) in gtmetrixMetrics" :key="label" class="col-6 col-sm-3 mb-3">
                        <div class="bg-light p-3 h-100 rounded border text-center">
                          <p class="text-xs text-secondary">{{ label }}</p>
                          <p class="h2 font-weight-semibold text-success">{{ value }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <p class="text-xs text-secondary mt-4 font-italic">
                    <strong>Note:</strong> This lab test is typically run with ad-blocking enabled. Ad provider policies often forbid optimizing their third-party scripts, so testing without them provides a more accurate measure of your site's core performance based on elements we can directly improve.
                  </p>
                </div>
                <!-- WordPress Overview Section -->
                <div class="bg-white p-4 rounded  border mb-4">
                  <div class="d-flex justify-content-between align-items-center mb-2">
                    <h2 class="h4 font-weight-semibold d-flex align-items-center">WordPress Overview</h2>
                    <button
                        class="btn btn-sm text-dark btn-light border"
                        @click="smoothScrollTo('wpo', 100)"
                        type="button"
                    >
                      View More Details
                    </button>
                  </div>
                  <!-- Overview Cards -->
                  <div class="row">
                    <!-- WordPress Version -->
                    <div class="col-12 col-sm-6 col-lg-4 mb-3">
                      <div class="bg-light h-100 p-3 rounded border h-100">
                        <h3 class="small text-muted mb-1">WordPress Version</h3>
                        <p class="h3 font-weight-semibold text-dark mb-0">{{ wpVer || 'NA' }}</p>
                      </div>
                    </div>

                    <!-- PHP Version -->
                    <div class="col-12 col-sm-6 col-lg-4 mb-3">
                      <div class="bg-light h-100 p-3 rounded border">
                        <h3 class="small text-muted mb-1">PHP Version</h3>
                        <p class="h3 font-weight-semibold text-success mb-0">{{ phpVer || 'NA' }}</p>
                      </div>
                    </div>

                    <!-- Active Theme -->
                    <div class="col-12 col-sm-6 col-lg-4 mb-3">
                      <div class="bg-light h-100 p-3 rounded border">
                        <h3 class="small text-muted mb-1">Active Theme</h3>
                        <p class="h3 font-weight-semibold text-dark mb-0">Astra Pro</p>
                      </div>
                    </div>

                    <!-- Total Plugins -->
                    <div class="col-12 col-sm-6 col-lg-4 mb-3">
                      <div class="bg-light h-100 p-3 rounded border ">
                        <h3 class="small text-muted mb-1">Total Plugins</h3>
                        <p class="h3 font-weight-semibold text-dark mb-0">{{plugins.length}}</p>
                      </div>
                    </div>

                    <!-- Total Themes -->
                    <div class="col-12 col-sm-6 col-lg-4 mb-3">
                      <div class="bg-light p-3 h-100 rounded border ">
                        <h3 class="small text-muted mb-1">Total Themes</h3>
                        <p class="h3 font-weight-semibold text-dark mb-0">3</p>
                      </div>
                    </div>

                    <!-- Vulnerabilities -->
                    <div class="col-12 col-sm-6 col-lg-4 mb-3">
                      <div class="bg-light p-3 h-100 rounded border ">
                        <h3 class="small text-muted mb-1">Vulnerabilities</h3>
                        <p class="h3 font-weight-semibold text-danger mb-0">{{ vulnerablePlugins.length }} Found</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div>
                  <!-- CRUX Metrics -->
                  <div v-if="parsedReport.length" id="crux" class="pdf-break-before card-section p-4 mb-5">
                    <div class="p-2">
                      <h5 class="report-section-heading mb-0">CRUX Metrics</h5>
                      <div class="mb-3">
                        <p class="text-secondary">Core Web Vitals are the metrics that Google uses to evaluate page experience. They measure loading, interactivity, and visual stability.</p>
                      </div>

                      <div class="alert alert-primary" style="background-color: #1f4bf1; font-size: 12px" role="alert">
                        This data comes from the Chrome User Experience Report (CrUX), which collects real performance metrics from actual Chrome users visiting this site. It provides valuable insights into how your website performs across different devices and network conditions. Please note that any recent optimizations won't appear immediately, as Google only updates CrUX data on the second Tuesday of every month.
                      </div>

                      <div class="mb-3 report-text-small">
                        <span class="badge bg-green-100 text-green-700 mr-2">Good</span>
                        <span class="badge bg-yellow-100 text-yellow-700 mr-2 "  >Needs Improvement</span>
                        <span class="badge bg-red-100 text-red-700">Poor</span>

                      </div>
                      <div v-for="(metric, idx) in combinedMetrics" :key="idx" class="mb-4">
                        <hr>
                        <button @click="openNotesModal(metric.type)" class="no-print btn btn-sm btn-default pull-right"> <i class="fa fa-plus"></i> Notes</button>
                        <h6>{{ metric.title }}</h6>
                        <p class="text-secondary">{{ metric.description }}</p>
                        <div class="row">
                          <div class="col-md-12 mb-2 report-text-small" >
                            <!-- Desktop -->
                            <div :class="idx < combinedMetrics.length - 1 ? 'mb-3' : '' ">
                              <div class="fw-bold mb-1">Desktop (%)</div>
                              <div class="progress rounded-pill" style="height: 30px;">
                                <div
                                    v-for="(bucket, i) in metric.desktop.histogram"
                                    :key="i"
                                    class="progress-bar"
                                    :class="getBarClass(i)"
                                    :style="{ width: bucket.density * 100 + '%' }"
                                >
                                  {{ (bucket.density * 100).toFixed(1) }}
                                </div>
                              </div>
                              <small class="text-muted">P75: {{ metric.desktop.p75 }}</small>
                            </div>
                          </div>

                          <div class="col-md-12" :class="idx < combinedMetrics.length ? 'mb-2' : ''">
                            <div>
                              <div class="fw-bold mb-1">Mobile (%)</div>
                              <div class="progress rounded-pill" style="height: 30px;">
                                <div
                                    v-for="(bucket, i) in metric.mobile.histogram"
                                    :key="i"
                                    class="progress-bar"
                                    :class="getBarClass(i)"
                                    :style="{ width: bucket.density * 100 + '%' }"
                                >
                                  {{ (bucket.density * 100).toFixed(1) }}
                                </div>
                              </div>
                              <small class="text-muted">P75: {{ metric.mobile.p75 }}</small>
                            </div>
                          </div>
                        </div>
                        <div class="card shadow-sm mb-4" v-if="comments[metric.type].length">
                          <div class="card-header py-2 bg-primary text-white d-flex justify-content-between align-items-center">
                            <h6 class="mb-0">Comments</h6>
                            <!--                            <span class="badge bg-light text-dark">{{ comments[metric.type].length }}</span>-->
                          </div>
                          <div class="card-body p-3" style="max-height: 300px; overflow-y: auto;">
                            <div
                                v-for="(comment, index) in comments[metric.type]"
                                :key="index"
                                class="mb-3 pb-2"
                                :class="index < comments[metric.type].length - 1 ? 'border-bottom' : ''"
                            >
                              <p class="mb-1 text-body">
                                <i class="bi bi-chat-left-text-fill text-primary me-2"></i>
                                <span v-html="comment.text" />
                              </p>
                              <div class="d-flex justify-content-between small text-muted">
                                <span><i class="bi bi-person-fill me-1"></i>{{ comment.addedBy }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else class="card-section p-4 mb-5">
                    <div class="mt-10">
                      <div class="alert alert-warning text-dark" role="alert"  style="background-color: #f1b433; font-size: 12px">
                        <strong>Note:</strong> Real CrUX data is not available for this domain. Showing estimated values for demonstration purposes.
                      </div>
                    </div>
                  </div>
                  <!-- GTmetrix Report -->
                  <div v-if="gtmetrixData" id="gtmetrix" class="pdf-break-before card-section px-4 my-2 ">
                    <div class="p-2">
                      <h5 class="h4 mb-0">
                        <b>GTmetrix Report</b>
                      </h5>
                      <button @click="openNotesModal('gtmatrics')" class="no-print btn btn-sm btn-default pull-right"> <i class="fa fa-plus"></i> Notes</button>
                    </div>
                    <div class="p-2">
                      <p class="report-text-small">
                        <a
                            :href="gtmetrixData.report_url"
                            target="_blank"
                            class="card-link"
                        >
                          📊 View Full Report
                        </a>
                        |
                        <a
                            :href="gtmetrixData.pdf_url"
                            target="_blank"
                            class="card-link"
                        >
                          📄 Download PDF
                        </a>
                      </p>
                      <div class="row py-3" >
                        <div class="col-md-5 ">
                          <div class="bg-light w-100 p-2">
                            <div class="d-flex align-items-center justify-content-around w-100">
                              <div class="d-flex align-items-center flex-column">
                                <div
                                    class="circular-progress"
                                    :style="{ background: getProgressStyle(gtmetrixData.performance_score) }"
                                >
                                  <div class="circular-inner">
                                    <div class="score-text">{{ gtmetrixData.performance_score }}%</div>
                                  </div>
                                </div>
                                <div><b>Performance</b></div>

                              </div>
                              <div class="d-flex align-items-center flex-column">
                                <div
                                    class="circular-progress"
                                    :style="{ background: getProgressStyle(gtmetrixData.structure_score) }"
                                >
                                  <div class="circular-inner">
                                    <div class="score-text">{{ gtmetrixData.structure_score }}%</div>
                                  </div>
                                </div>
                                <div><b>Structure</b></div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-7 p-0" style="align-content: center">
                          <div class="my-auto d-flex flex-column justify-content-between w-100 h-100">
                            <div>
                              <div class="row">
                                <div class="col-md-3 ">
                                  <div class="text-center bg-light  ">
                                    <strong>LCP:</strong><br> {{ (gtmetrixData.lcp / 1000).toFixed(1) }} s
                                  </div>
                                </div>
                                <div class="col-md-3 ">
                                  <div class="text-center bg-light ">
                                    <strong>CLS:</strong><br> {{ gtmetrixData.cls.toFixed(2) }}
                                  </div>
                                </div>
                                <div class="col-md-3  ">
                                  <div class="text-center bg-light ">
                                    <strong>TBT:</strong> <br>{{ gtmetrixData.tbt }} ms
                                  </div>
                                </div>
                                <div class="col-md-3 ">
                                  <div class="text-center bg-light ">
                                    <strong>TTFB:</strong><br> {{ gtmetrixData.ttfb }} ms
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div>
                              <div class="row">
                                <div class="col-md-3 ">
                                  <div class="text-center bg-light ">
                                    <strong>Speed Index:</strong><br> {{ gtmetrixData.speed_index }} ms
                                  </div>
                                </div>
                                <div class="col-md-3 ">
                                  <div class="text-center bg-light ">
                                    <strong>Fully Loaded:</strong><br> {{ (gtmetrixData.fully_loaded_time / 1000).toFixed(1) }} s
                                  </div>
                                </div>
                                <div class="col-md-3 ">
                                  <div class="text-center bg-light ">
                                    <strong>Page Requests:</strong> <br>{{ gtmetrixData.page_requests }}
                                  </div>

                                </div>
                                <div class="col-md-3 ">
                                  <div class="text-center bg-light ">
                                    <strong>Page Size:</strong> <br>{{ (gtmetrixData.page_bytes / 1024).toFixed(1) }} KB
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div v-if="gtmetrixData.recommendations && gtmetrixData.recommendations.length" style="margin-top: 30px">
                        <h6>Recommendations:</h6>
                        <ul class="list-group report-text-small">
                          <li
                              v-for="(rec, i) in gtmetrixData.recommendations"
                              :key="i"
                              class="list-group-item"
                          >
                            <div class="d-flex justify-content-between align-items-start">
                              <div>
                                <strong>{{ rec.issue }}</strong>
                                <p class="mb-1">
                                  <small>Affects: <span class="fw-bold">{{ rec.affects }}</span></small>
                                </p>
                              </div>
                              <span class="badge" :class="rec.severity.toLowerCase().includes('med') ? 'bg-warning' : rec.severity.toLowerCase().includes('high') ? 'bg-danger' : 'bg-default'">{{ rec.severity }}</span>
                            </div>
                            <p class="mb-1">{{ rec.solution }}</p>
                            <p v-if="rec.details" class="mb-0 text-muted">
                              <small>{{ rec.details }}</small>
                            </p>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="card shadow-sm mb-4" v-if="comments['gtmatrics'].length">
                    <div class="card-header py-2 bg-primary text-white d-flex justify-content-between align-items-center">
                      <h6 class="mb-0">Comments</h6>
                      <!--                    <span class="badge bg-light text-dark">{{ comments['gtmatrics'].length }}</span>-->
                    </div>
                    <div class="card-body p-3" style="max-height: 300px; overflow-y: auto;">
                      <div
                          v-for="(comment, index) in comments['gtmatrics']"
                          :key="index"
                          class="mb-3  pb-2"
                          :class="index < comments['gtmatrics'].length - 1 ? 'border-bottom' : ''"
                      >
                        <p class="mb-1 text-body">
                          <i class="bi bi-chat-left-text-fill text-primary me-2"></i>
                          <span v-html="comment.text" />
                        </p>
                        <div class="d-flex justify-content-between small text-muted">
                          <span><i class="bi bi-person-fill me-1"></i>{{ comment.addedBy }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="wpoDomain" id="wpo" class="card-section p-4 mb-5 pdf-break-before mt-4">
                    <div class="py-2 align-items-center">
                      <button @click="openNotesModal('plugins')" class="no-print btn btn-sm btn-default pull-right"> <i class="fa fa-plus"></i> Notes</button>
                      <h5 class="mb-0"> <b>WordPress Optimization</b></h5>
                    </div>
                    <div v-if="hasWpoData" class="text-secondary">
                      <p><strong>IP Address:</strong> {{ wpoIP || 'NA' }}</p>
                      <p><strong>PHP Version:</strong> {{ phpVer || 'NA' }}</p>
                      <p><strong>WordPress Version:</strong> {{ wpVer || 'NA' }}</p>

                      <div class="card shadow-sm mb-4" v-if="comments['plugins'].length">
                        <div class="card-header py-2 bg-primary text-white d-flex justify-content-between align-items-center">
                          <h6 class="mb-0">Comments</h6>
                          <!--                    <span class="badge bg-light text-dark">{{ comments['plugins'].length }}</span>-->
                        </div>
                        <div class="card-body p-3" style="max-height: 300px; overflow-y: auto;">
                          <div
                              v-for="(comment, index) in comments['plugins']"
                              :key="index"
                              class="mb-3  pb-2"
                              :class="index < comments['plugins'].length - 1 ? 'border-bottom' : ''"
                          >
                            <p class="mb-1 text-body">
                              <i class="bi bi-chat-left-text-fill text-primary me-2"></i>
                              <span v-html="comment.text" />
                            </p>
                            <div class="d-flex justify-content-between small text-muted">
                              <span><i class="bi bi-person-fill me-1"></i>{{ comment.addedBy }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="py-2 align-items-center">
                        <button @click="openNotesModal('pluginlist')" class="no-print btn btn-sm btn-default pull-right"> <i class="fa fa-plus"></i> Notes</button>
                        <h4 class="mt-4">Active Plugins ({{ safePlugins.length }})</h4>
                      </div>
                      <div class="table-responsive">
                        <table class="table table-hover table-bordered table-sm">
                          <thead class="thead-light">
                          <tr>
                            <th width="30%">Plugins</th>
                            <th class="text-center">Version</th>
                            <th class="text-center">Status</th>
                            <th class="text-center">Security</th>
                          </tr>
                          </thead>
                          <tbody  class="text-secondary" v-for="(plugin, index) in plugins" :key="plugin.name">
                          <tr>
                            <td>{{ plugin.name }}</td>

                            <td class="text-center">
                              {{ plugin.version }}
                            </td>
                            <td class="text-center">
                          <span :class="['badge', plugin.status === 'active' ? 'text-green-700 bg-green-100' : 'text-red-700 bg-red-100']">
                            {{ plugin.status === 'active' ? 'Active' : 'Inactive' }}
                          </span>
                            </td>

                            <!--                      <td class="text-center">-->
                            <!--                        {{ plugin.version }}-->
                            <!--                      </td>-->

                            <td class="text-center">
                              <template>
                          <span
                              class="badge"
                              :class="getVulnerabilityClass(plugin.security)"
                          >
                            {{Array.isArray(plugin.security) ? 'vulnerable' : plugin.security }}
                          </span>
                              </template>
                            </td>
                          </tr>
                          <tr v-if="Array.isArray(plugin.security)">
                            <td colspan="4">
                              <div
                                  class="alert alert-danger mb-3"
                              >
                                <strong>{{ plugin.name }}</strong>
                                <div
                                    v-for="(issue, i) in plugin.security"
                                    :key="i"
                                    class="mt-2"
                                >
                                  <div><strong>{{ issue.title }}</strong></div>
                                  <small>
                                    {{ issue.description }}<br />
                                    <strong>Severity:</strong> {{ issue.severity }}<br />
                                    <strong>Affected Version:</strong> {{ issue.affected_version || 'Unknown' }}
                                  </small>
                                </div>
                              </div>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div v-else class="card-body">
                      <p>No WPO data available.</p>
                    </div>
                  </div>
                  <div class="card shadow-sm mb-4" v-if="comments['pluginlist'] && comments['pluginlist'].length">
                    <div class="card-header py-2 bg-primary text-white d-flex justify-content-between align-items-center">
                      <h6 class="mb-0">Comments</h6>
                      <!--                    <span class="badge bg-light text-dark">{{ comments['plugins'].length }}</span>-->
                    </div>
                    <div class="card-body p-3" style="max-height: 300px; overflow-y: auto;">
                      <div
                          v-for="(comment, index) in comments['pluginlist']"
                          :key="index"
                          class="mb-3  pb-2"
                          :class="index < comments['pluginlist'].length - 1 ? 'border-bottom' : ''"
                      >
                        <p class="mb-1 text-body">
                          <i class="bi bi-chat-left-text-fill text-primary me-2"></i>
                          <span v-html="comment.text" />
                        </p>
                        <div class="d-flex justify-content-between small text-muted">
                          <span><i class="bi bi-person-fill me-1"></i>{{ comment.addedBy }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Footer -->
                <footer class="text-center mt-5 small text-secondary">
                  <p>This report was generated by the BigScoots Performance Analysis Tool.</p>
                  <p>&copy; <span id="footer-year"></span> BigScoots. All Rights Reserved.</p>
                </footer>
              </div>
            </div>
            <!-- WPO Report -->
            <!-- Fallback -->
            <div v-if="!loading && (!parsedReport.length && !gtmetrixData)" class="alert alert-info">
              No report yet. Submit a URL above to run an audit.
            </div>
          </section>
        </div>
      </div>
    </div>
    <report-notes-modal ref="notes" />

    <!-- Modal -->
    <div class="new-findings-modal position-relative">
      <div class="modal fade newKeyFindingsModal" id="newKeyFindingsModal" tabindex="-1" role="dialog" aria-labelledby="newKeyFindingsModal" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">{{siteUrl}}</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label>Key Findings & Recommendations</label>
                <vue-editor v-model="keyFindings" :editor-toolbar="customToolbar" />
                <h5 class="mt-3 mb-0" v-if="keyFindings !== ''">Preview</h5>
                <div v-html="keyFindings"></div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
              <button type="button" class="btn btn-primary" :disabled="loading" @click="submitKetFindings()">
                <div class="loader small_loader" v-if="loading"></div>
                <span v-else>Submit</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Domain Selection Modal -->
    <div class=" position-relative">
      <div class="modal fade" id="domainSelectionModal" tabindex="-1" role="dialog" aria-labelledby="domainSelectionModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="domainSelectionModalLabel">
                <i class="fa fa-globe mr-2"></i>
                Multiple Domains Found
              </h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="alert alert-info">
                <i class="fa fa-info-circle mr-2"></i>
                We found multiple domains with the name "<strong>{{ urlInput }}</strong>" in our system.
                Please select the specific domain you want to audit:
              </div>

              <div class="domain-selection-list">
                <div
                    v-for="(domain, index) in multipleDomains"
                    :key="index"
                    class="domain-option card mb-3"
                    :class="{ 'selected': selectedDomainIndex === index }"
                    @click="selectDomain(index)"
                >
                  <div class="card-body">
                    <div class="row align-items-center">
                      <div class="col-md-1">
                        <div class="custom-control custom-radio" style="min-height: 2.5rem">
                          <input
                              type="radio"
                              :id="`domain-${index}`"
                              :value="index"
                              v-model="selectedDomainIndex"
                              class="custom-control-input"
                          >
                          <label class="custom-control-label" :for="`domain-${index}`"></label>
                        </div>
                      </div>
                      <div class="col-md-11">
                        <h6 class="mb-1">
                          <i class="fa fa-globe text-primary mr-2"></i>
                          {{ domain.domain }}
                        </h6>
                        <p class="text-muted mb-1">
                          <i class="fa fa-server mr-1"></i>
                          <strong>IP:</strong> {{ domain.ip || 'N/A' }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">
                <i class="fa fa-times mr-2"></i>
                Cancel
              </button>
              <button
                  type="button"
                  class="btn btn-primary"
                  :disabled="selectedDomainIndex === null"
                  @click="proceedWithSelectedDomain"
              >
                <i class="fa fa-check mr-2"></i>
                Continue with Selected Domain
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {db} from "@/firebase/init";
import swal from "sweetalert2";
import moment from "moment/moment";
import { VueEditor } from "vue2-editor";
import copyButtonMixin from "@/mixins/copyButtonMixin";
import crypto from 'crypto-js';


export default {
  name: "PerformanceAuditReport",
  mixins: [copyButtonMixin],
  components: {
    reportNotesModal: () =>
        import(
            /* webpackChunkName: "accDetailsUpdate" */ "../../../components/Admin/Cloudflare/reportNotesModal.vue"
            ),
    VueEditor
  },
  data() {
    return {
      urlInput: "",
      adblockChecked: false,
      domainData: null,
      loading: false,
      parsedReport: [],
      docId: null,
      gtmetrixData: null,
      generatedLink: null,
      showLinkModal: false,
      wpoData: null,
      siteUrl: null,
      crux: null,
      comments: {
        lcp: [],
        cls: [],
        inp: [],
        gtmatrics: [],
        plugins: [],
        pluginlist: [],
      },
      keyFindings: '',
      uodatedKeyFindings: '',
      customToolbar: [
        ["bold", "italic", "underline", "strike"],
        [{ script: "sub" }, { script: "super" }],
        [{ color: [] }, { background: [] }],
        ["link"],
        ["clean"]
      ],
      // New properties for tab interface and previous reports functionality
      activeTab: 'new-audit',
      previousReports: [],
      loadingReports: false,
      // Properties to store original report metadata when viewing previous reports
      reportAuthor: null,
      reportAuthorEmailHash: null,
      reportCreatedDate: null,
      // Search functionality
      searchTerm: '',
      searchResults: [],
      isSearching: false,
      searchTimeout: null,
      // Multiple domain selection properties
      multipleDomains: [],
      showDomainSelectionModal: false,
      selectedDomainIndex: null,
    };
  },
  computed: {
    aesSecret() {
      return this.$store.getters["crypto/aesSecret"];
    },
    gtmetrixMetrics () {
      const d = this.gtmetrixData || {};
      return {
        LCP: d.lcp ? (d.lcp / 1000).toFixed(1) + 's' : '–',
        CLS: d.cls !== undefined ? d.cls.toFixed(2) : '–',
        TBT: d.tbt ? d.tbt + 'ms' : '–',
        TTFB: d.ttfb ? (d.ttfb / 1000).toFixed(1) + 's' : '–',
        "Speed Index": d.speed_index ? (d.speed_index / 1000).toFixed(1) + 's' : '–',
        "Fully Loaded": d.fully_loaded_time ? (d.fully_loaded_time / 1000).toFixed(1) + 's' : '–',
        "Page Requests": d.page_requests || '–',
        "Page Size": d.page_bytes ? (d.page_bytes / (1024 * 1024)).toFixed(1) + ' MB' : '–'
      };
    },
    currentDate() {
      const date = new Date()
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    },
    user() {
      return this.$store.getters.user;
    },
    userEmailHash() {
      return this.$store.getters.emailHashGravatar;
    },
    // Computed properties for displaying correct report metadata
    displayAuthor() {
      return this.reportAuthor || this.user.firstName;
    },
    displayAuthorEmailHash() {
      return this.reportAuthorEmailHash || this.userEmailHash;
    },
    displayReportDate() {
      return this.reportCreatedDate || this.dateFormat(new Date());
    },
    // Computed property for filtered reports based on search
    filteredReports() {
      if (!this.searchTerm.trim()) {
        return this.previousReports;
      }
      // If we have search results from Firestore, use those; otherwise filter locally
      if (this.searchResults.length > 0) {
        return this.searchResults;
      }
      // Fallback to local filtering if Firestore search fails
      return this.previousReports.filter(report => {
        const domain = report.domain || report.siteUrl || '';
        return domain.toLowerCase().includes(this.searchTerm.toLowerCase());
      });
    },
    combinedMetrics() {
      const desktop = this.parsedReport.find(r => r.formFactor === "Desktop");
      const mobile = this.parsedReport.find(r => r.formFactor === "Mobile");
      if (!desktop || !mobile) return [];
      return desktop.metrics.map((metric, i) => ({
        title: metric.title,
        type: metric.type,
        description: metric.description,
        desktop: metric,
        mobile: mobile.metrics[i]
      }));
    },
    hasWpoData() {
      return this.wpoData && this.wpoData.success && this.wpoData.wpo_data.domains.length > 0;
    },
    wpoDomain() {
      return this.hasWpoData ? this.wpoData.wpo_data.domains[0].domain : null;
    },
    wpoIP() {
      return this.hasWpoData ? this.wpoData.wpo_data.domains[0].ip : null;
    },
    phpVer() {
      return this.hasWpoData ? this.wpoData.wpo_data.domains[0].phpVer : null;
    },
    wpVer() {
      return this.hasWpoData ? this.wpoData.wpo_data.domains[0].wpVer : null;
    },
    plugins() {
      if (!this.hasWpoData) return [];
      return this.wpoData.wpo_data.domains[0].plugins
    },
    safePlugins() {
      if (!this.hasWpoData) return [];
      return this.wpoData.wpo_data.domains[0].plugins.filter(
          (p) => (p.security === 'Safe' && p.name)
      );
    },
    vulnerablePlugins() {
      if (!this.hasWpoData) return [];
      return this.wpoData.wpo_data.domains[0].plugins.filter(
          (p) => Array.isArray(p.security)
      );
    }
  },
  methods: {
    async generateLink() {
      $(document).ready(function() {
        $(".modal-backdrop").appendTo(".link-share-modal");
      });

      if (!this.docId) {
        swal('Error', 'Please run the audit first to generate a link.', 'error');
        return;
      }
      const encodedId = crypto.AES.encrypt(this.docId, this.aesSecret).toString().split('/').join('Por21Ld') .split('+').join('xMl3Jk') .split('=').join('Ml32') //btoa();
      this.generatedLink = `https://wpo.bigscoots.com/report/performance-audit?reportId=${encodedId}`;
      this.showLinkModal = true;
    },

    async copyLink() {
      try {
        await navigator.clipboard.writeText(this.generatedLink);
        this.doCopy(this.generatedLink)
        // swal('Success', 'Link copied to clipboard!', 'success');
      } catch (err) {
        console.error('Failed to copy link:', err);
        swal('Error', 'Failed to copy link to clipboard', 'error');
      }
    },

    getCruxMetric(metric) {
      const mobile = this.parsedReport.find(r => r.formFactor === "Mobile");
      if (!mobile) return {};

      const fallback = { p75: 'N/A', description: '', note: '' };

      switch (metric) {
        case 'lcp':
          return {
            p75: mobile.metrics.find(m => m.type === 'lcp').p75 || 'N/A',
            description: 'Largest Contentful Paint',
            note: `Measures loading performance.<br> Target: < 2.5s`
          };
        case 'inp':
          return {
            p75: mobile.metrics.find(m => m.type === 'inp').p75 || 'N/A',
            description: 'Interaction to Next Paint',
            note: `Measures interactivity.<br> Target: < 200ms`
          };
        case 'cls':
          return {
            p75: mobile.metrics.find(m => m.type === 'cls').p75 || 'N/A',
            description: 'Cumulative Layout Shift',
            note: `Measures visual stability.<br> Target: < 0.1`
          };
        case 'ttfb':
          if (this.crux) {
            const ttfb = this.crux.data.mobile.full.metrics.experimental_time_to_first_byte.percentiles.p75 || 0;
            return {
              p75: (ttfb / 1000).toFixed(1) + 's',
            };
          } else {
            return fallback;
          }
        case 'fcp':
          if (this.crux) {
            const fcp = this.crux.data.mobile.full.metrics.first_contentful_paint.percentiles.p75 || 0;
            return {
              p75: (fcp / 1000).toFixed(1) + 's',
            };
          } else {
            return fallback;
          }
        default:
          return fallback;
      }
    },
    getCruxBadge(metric) {
      const val = this.getCruxMetric(metric).p75;
      const numeric = parseFloat(val);
      switch (metric) {
        case 'lcp':
          if (numeric < 2.5) return { level: 'Good' };
          if (numeric < 4.0) return { level: 'Needs Improvement' };
          return { level: 'Poor' };
        case 'inp':
          if (numeric < 200) return { level: 'Good' };
          if (numeric < 500) return { level: 'Needs Improvement' };
          return { level: 'Poor' };
        case 'cls':
          if (numeric < 0.1) return { level: 'Good' };
          if (numeric < 0.25) return { level: 'Needs Improvement' };
          return { level: 'Poor' };
        default:
          return { level: 'N/A' };
      }
    },
    async submitKetFindings () {
      try {
        this.uodatedKeyFindings = this.keyFindings
        await db.collection('performance-report').doc(this.docId).update({
          keyFindings: this.keyFindings,
          keyFindingsUpdatedBy: this.user.firstName + ' ' + this.user.lastName,
          keyFindingsUpdatedByEmailHash: this.userEmailHash,
          modified: new Date().toISOString()
        })
      } catch (e) {
        console.log('Error in saving key findings', e.toString())
      } finally {
        $('#newKeyFindingsModal').modal('hide');
      }
    },
    fixModal() {
      /* eslint-disable */
      $(document).ready(function() {
        $(".modal-backdrop").appendTo(".new-findings-modal");
      });
      /* eslint-enable */
    },
    dateFormat (date) {
      return moment(date).format("MMM Do, YYYY")
    },
    getProgressStyle(score) {
      const angle = (score / 100) * 360
      return `conic-gradient(#28a745 ${angle}deg, #e9ecef 0deg)`
    },
    openNotesModal (type) {
      this.$refs.notes.load(this.comments,type, this.docId)
    },
    async downloadPdf() {
      try {
        if (!this.docId) {
          swal('Error', 'Please run the audit first to generate a PDF.', 'error');
          return;
        }

        // Show loading state
        const downloadBtn = document.querySelector('.download-pdf-btn');
        const originalText = downloadBtn.querySelector('span:last-child').textContent;
        downloadBtn.querySelector('span:last-child').textContent = 'Generating PDF...';
        downloadBtn.disabled = true;

        const encodedId = crypto.AES.encrypt(this.docId, this.aesSecret).toString().split('/').join('Por21Ld') .split('+').join('xMl3Jk') .split('=').join('Ml32')
        const response = await this.$http.post('/utilities/generate-audit-pdf', {
          grant_type: 'token',
          reportId: encodedId,
        }, {
          responseType: 'blob', // Important: Set response type to blob for binary data
          timeout: 300000 // 5 minutes timeout to match backend
        });


        // Check if response is actually a blob and has content
        if (!response.data || response.data.size === 0) {
          throw new Error('Empty PDF response from server');
        }

        // Check if response is an error JSON instead of PDF
        if (response.data.type === 'application/json') {
          const text = await response.data.text();
          throw new Error('Server returned error instead of PDF: ' + text);
        }

        // Try alternative approach: Use the response data directly
        let blob;
        
        // Method 1: Try using response.data directly if it's already a blob
        if (response.data instanceof Blob) {
          console.log('Using response.data as blob directly');
          blob = response.data;
        } else {
          console.log('Creating new blob from response.data');
          blob = new Blob([response.data], { type: 'application/pdf' });
        }
        
        // Check if blob has PDF signature
        const arrayBuffer = await blob.arrayBuffer();
        const uint8Array = new Uint8Array(arrayBuffer);
        const pdfSignature = String.fromCharCode(...uint8Array.slice(0, 4));

        if (pdfSignature !== '%PDF') {
          console.error('Invalid PDF signature. First 20 bytes:', String.fromCharCode(...uint8Array.slice(0, 20)));
          throw new Error('Invalid PDF file received from server');
        }
        
        // Create blob URL
        const url = window.URL.createObjectURL(blob);

        // Alternative download method using fetch API
        try {
          const link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          link.download = `performance-report-${new Date().getTime()}.pdf`;
          
          document.body.appendChild(link);
          link.click();
          
          // Cleanup
          setTimeout(() => {
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          }, 1000);
          
        } catch (downloadError) {
          console.error('Download failed, trying alternative method:', downloadError);
          
          // Alternative: Open in new window
          window.open(url, '_blank');
        }
        
        // Reset button state
        downloadBtn.querySelector('span:last-child').textContent = originalText;
        downloadBtn.disabled = false;

        swal('Success', 'PDF downloaded successfully!', 'success');
        
      } catch (error) {
        console.error('Error downloading PDF:', error);
        
        // Reset button state
        const downloadBtn = document.querySelector('.download-pdf-btn');
        if (downloadBtn) {
          downloadBtn.querySelector('span:last-child').textContent = 'Download Report as PDF';
          downloadBtn.disabled = false;
        }

        let errorMessage = 'Failed to generate PDF. Please try again.';
        
        if (error.response) {
          if (error.response.status === 504) {
            errorMessage = 'PDF generation timed out. The report may be too large or complex.';
          } else if (error.response.status === 400) {
            errorMessage = 'Invalid report ID. Please run the audit again.';
          } else if (error.response.status === 500) {
            errorMessage = 'Server error while generating PDF. Please contact support.';
          }
        } else if (error.code === 'ECONNABORTED') {
          errorMessage = 'Request timed out. Please try again.';
        }
        
        swal('Error', errorMessage, 'error');
      }
    },
    async submitAudit() {
      // Reset form state first
      // Reset form state
      this.parsedReport = [];
      this.gtmetrixData = null;
      this.siteUrl = null;
      this.wpoData = null;
      this.crux = null;
      this.docId = null;
      this.generatedLink = null;
      this.uodatedKeyFindings = '';
      this.keyFindings = '';
      this.comments = {
        lcp: [],
        cls: [],
        inp: [],
        gtmatrics: [],
        plugins: [],
        pluginlist: []
      };
      // Clear search when resetting form
      this.clearSearchResults();
      this.searchTerm = '';
      // this.resetFormState();
      this.loading = true;
      this.parsedReport = [];
      this.gtmetrixData = null;
      this.siteUrl = null;
      this.wpoData = null;
      this.crux = null;
      // Reset report metadata for new audit
      this.reportAuthor = null;
      this.reportAuthorEmailHash = null;
      this.reportCreatedDate = null;
      this.urlInput = this.urlInput.trim()
      try {
        let query = await db.collection('domains').where('domain', '==', this.urlInput).get();
        
        // Handle multiple domains
        if (query.size > 1) {
          this.multipleDomains = query.docs.map(doc => ({ id: doc.id, ...doc.data() }));
          this.selectedDomainIndex = null;
          this.showDomainSelectionModal = true;
          this.loading = false;
          $('#domainSelectionModal').modal('show');
          $('.modal-backdrop').removeClass("modal-backdrop");
          return;
        }
        
        // Handle single or no domain
        this.domainData = query.size ? query.docs[0].data() : {}
        await this.continueWithDomainData();
      } catch (err) {
        console.error(err);
      } finally {
        if (!this.showDomainSelectionModal) {
          this.loading = false;
          // Ensure we stay on the new audit tab after running an audit
          this.activeTab = 'new-audit';
          
          // Smooth scroll to report content after audit completion
          if (this.parsedReport.length || this.gtmetrixData || this.wpoDomain) {
            this.smoothScrollTo('reportContent', 100);
          }
        }
      }
    },

    async continueWithDomainData() {
      try {
        const { ip } = this.domainData;
        if (ip) {
          try {
            let response = await this.$http.post('/utilities/get-canonical-url-redirect', {
              grant_type: 'token',
              ip: ip,
              domain: this.urlInput
            });
            console.log('response', response.data);

            response= JSON.parse(response.data)

            if (response.success) {
              this.siteUrl = response.siteurl;
            }
          } catch (e) {
            // this.loading = false;
            console.log(e.toString());
            this.loading = false;
            return;
          }
        } else {
          this.siteUrl = this.urlInput
        }
        
        if (this.siteUrl) {
          let response = await this.$http.post('/utilities/generate-performance-report', {
            grant_type: 'token',
              url: this.siteUrl,
              adblock: this.adblockChecked
          });
          // const response = await fetch("https://n8n.bigscoots.dev/webhook/f7f39f47-1b40-48f4-abbc-37bf2791b0cf", {
          //   method: "POST",
          //   headers: {
          //     "Content-Type": "application/json",
          //     "Authorization": "Bearer QlkComRiKHyY9cRerxj4c7UYM4Rle53SdSBO9mzf"
          //   },
          //   body: JSON.stringify({
          //     url: this.siteUrl,
          //     adblock: this.adblockChecked
          //   })
          // });
          // const result = await response.json();
          const result = await response.data.data
          console.log('result',result)
          this.saveInDB(result)

          // Parse CrUX
          this.crux = result.find(obj => obj.type === "crux");
          if (this.crux && this.crux.data) {
            for (const factor of ["desktop", "mobile"]) {
              if (this.crux.data[factor]) {
                this.parsedReport.push({
                  formFactor: factor === "desktop" ? "Desktop" : "Mobile",
                  metrics: this.parseMetrics(this.crux.data[factor].full.metrics)
                });
              }
            }
          }
          console.log('this.parsedReport', this.parsedReport)
          // Parse GTmetrix
          const gtmetrix = result.find(obj => obj.type === "gtmetrix");
          this.wpoData = result.find(obj => obj.type === "wpo");
          if (gtmetrix) {
            this.gtmetrixData = gtmetrix.data;
            console.log('this.gtmetrixData', this.gtmetrixData)
          }
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
        // Ensure we stay on the new audit tab after running an audit
        this.activeTab = 'new-audit';
        
        // Smooth scroll to report content after audit completion
        if (this.parsedReport.length || this.gtmetrixData || this.wpoDomain) {
          this.smoothScrollTo('reportContent', 100);
        }
      }
    },
    computeGrade(score) {
      if (score >= 90) return 'A';
      if (score >= 80) return 'B';
      if (score >= 70) return 'C';
      if (score >= 60) return 'D';
      return 'F';
    },
    async saveInDB(resp) {
      try {
        const ref = await db.collection('performance-report').add({
          reportData: resp,
          siteUrl: this.siteUrl,
          addedByEmailHash: this.userEmailHash,
          addedBy: `${this.user.firstName} ${this.user.lastName}`,
          uid: this.domainData.uid || '',
          domain: this.urlInput || '',
          ip: this.domainData.ip || '',
          comments: this.comments,
          createdAt: new Date().toISOString()
        });
        this.docId = ref.id
        await this.generateLink()
      } catch (e) {
        console.log('Error in adding report in DB')
      }
    },
    parseMetrics(metrics) {
      return [
        {
          title: "Largest Contentful Paint (LCP)",
          type: 'lcp',
          description: "Measures loading performance. LCP marks the time at which the largest text or image is painted.",
          histogram: metrics.largest_contentful_paint ? metrics.largest_contentful_paint.histogram : [],
          p75: metrics.largest_contentful_paint ? (Number(metrics.largest_contentful_paint.percentiles.p75) / 1000).toFixed(1) + "s" : 'N/A'
        },
        {
          title: "Cumulative Layout Shift (CLS)",
          type: 'cls',
          description: "Measures visual stability. CLS quantifies how often users experience unexpected layout shifts",
          histogram: metrics.cumulative_layout_shift ? metrics.cumulative_layout_shift.histogram : [],
          p75: metrics.cumulative_layout_shift ? metrics.cumulative_layout_shift.percentiles.p75 : 'N/A'
        },
        {
          title: "Interaction to Next Paint (INP)",
          type: 'inp',
          description: "Measures responsiveness. INP measures the time from when a user interacts with the page to when the next frame is painted",
          histogram: metrics.interaction_to_next_paint ? metrics.interaction_to_next_paint.histogram : [],
          p75: metrics.interaction_to_next_paint ? metrics.interaction_to_next_paint.percentiles.p75 + "ms" : 'N/A'
        }
      ];
    },
    getBarClass(index) {
      return ["bg-success", "bg-warning text-dark", "bg-danger"][index] || "bg-secondary";
    },

    getVulnerabilityClass(val){
      let clas = '';
      if(val === 'Safe') {
        clas = 'text-green-700 bg-green-100'
      } else {
        clas = 'text-red-700 bg-red-100'
      }
      return clas
    },

    // New methods for tab interface and previous reports functionality
    switchTab(tabName) {
      this.activeTab = tabName;
      
      // Load previous reports when switching to that tab
      if (tabName === 'previous-reports' && this.previousReports.length === 0) {
        this.loadPreviousReports();
      }
    },

    async loadPreviousReports() {
      this.loadingReports = true;
      try {
        // Try to order by createdAt first, fallback to no ordering if index doesn't exist
        let query;
        try {
          query = await db.collection('performance-report')
            .orderBy('createdAt', 'desc')
            .limit(50)
            .get();
        } catch (indexError) {
          console.log('Using fallback query without ordering');
          // Fallback to no ordering if index doesn't exist
          query = await db.collection('performance-report')
            .limit(50)
            .get();
        }
        
        this.previousReports = query.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        
      } catch (error) {
        console.error('Error loading previous reports:', error);
        swal('Error', 'Failed to load previous reports. Please try again.', 'error');
      } finally {
        this.loadingReports = false;
      }
    },

    resetFormState() {
      // Reset form state
      this.urlInput = "";
      this.adblockChecked = false;
      this.parsedReport = [];
      this.gtmetrixData = null;
      this.siteUrl = null;
      this.wpoData = null;
      this.crux = null;
      this.docId = null;
      this.generatedLink = null;
      this.uodatedKeyFindings = '';
      this.keyFindings = '';
      this.comments = {
        lcp: [],
        cls: [],
        inp: [],
        gtmatrics: [],
        plugins: [],
        pluginlist: []
      };
      // Reset report metadata to show current user/date for new reports
      this.reportAuthor = null;
      this.reportAuthorEmailHash = null;
      this.reportCreatedDate = null;
      // Clear search when resetting form
      this.clearSearchResults();
      this.searchTerm = '';
      
      // Reset domain selection state
      this.resetDomainSelection();
    },

    async loadReport(report) {
      try {
        // Reset form state first
        this.resetFormState();
        
        // Set the report data to display
        this.docId = report.id;
        this.siteUrl = report.siteUrl;
        this.urlInput = report.domain || '';
        this.uodatedKeyFindings = report.keyFindings || '';
        this.keyFindings = report.keyFindings || '';
        this.comments = report.comments ? {...this.comments, ...report.comments} : {
          lcp: [],
          cls: [],
          inp: [],
          gtmatrics: [],
          plugins: [],
          pluginlist: []
        };

        // Set the original report metadata
        this.reportAuthor = report.addedBy || 'Unknown';
        this.reportAuthorEmailHash = report.addedByEmailHash || '';
        this.reportCreatedDate = report.createdAt || this.dateFormat(new Date());

        // Parse the report data
        if (report.reportData && Array.isArray(report.reportData)) {
          const result = report.reportData;
          
          // Parse CrUX
          this.crux = result.find(obj => obj.type === "crux");
          if (this.crux && this.crux.data) {
            this.parsedReport = [];
            for (const factor of ["desktop", "mobile"]) {
              if (this.crux.data[factor]) {
                this.parsedReport.push({
                  formFactor: factor === "desktop" ? "Desktop" : "Mobile",
                  metrics: this.parseMetrics(this.crux.data[factor].full.metrics)
                });
              }
            }
          }
          
          // Parse GTmetrix
          const gtmetrix = result.find(obj => obj.type === "gtmetrix");
          this.wpoData = result.find(obj => obj.type === "wpo");
          if (gtmetrix) {
            this.gtmetrixData = gtmetrix.data;
          }
        }

        // Generate shareable link
        await this.generateLink();
        
        // Keep the user on the current tab (don't auto-switch to new-audit)
        
        // Smooth scroll to report content after loading
        this.smoothScrollTo('reportContent', 100);
        
      } catch (error) {
        console.error('Error loading report:', error);
        swal('Error', 'Failed to load the report. Please try again.', 'error');
      }
    },

    // Search functionality methods
    async onSearchInput() {
      // Debounce search to avoid too many queries
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        if (this.searchTerm.trim()) {
          this.searchReports();
        } else {
          this.clearSearchResults();
        }
      }, 300);
    },

    async searchReports() {
      if (!this.searchTerm.trim()) return;

      this.isSearching = true;
      try {
        // Search in Firestore by domain field
        const query = await db.collection('performance-report')
          .where('domain', '>=', this.searchTerm.toLowerCase())
          .where('domain', '<=', this.searchTerm.toLowerCase() + '\uf8ff')
          .limit(20)
          .get();

        this.searchResults = query.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));

        // If no results from exact domain search, try searching in siteUrl
        if (this.searchResults.length === 0) {
          try {
            const siteUrlQuery = await db.collection('performance-report')
              .where('siteUrl', '>=', this.searchTerm.toLowerCase())
              .where('siteUrl', '<=', this.searchTerm.toLowerCase() + '\uf8ff')
              .limit(20)
              .get();

            this.searchResults = siteUrlQuery.docs.map(doc => ({
              id: doc.id,
              ...doc.data()
            }));
          } catch (siteUrlError) {
            console.log('SiteUrl search failed, using local filtering');
          }
        }

      } catch (error) {
        console.error('Error searching reports:', error);
        // Fallback to local filtering if Firestore search fails
        this.searchResults = [];
      } finally {
        this.isSearching = false;
      }
    },

    clearSearch() {
      this.searchTerm = '';
      this.clearSearchResults();
    },

    clearSearchResults() {
      this.searchResults = [];
      this.isSearching = false;
    },

    // Smooth scrolling utility method
    smoothScrollTo(elementId, offset = 0) {
      // this.$nextTick(() => {
      //   const element = document.getElementById(elementId);
      //   if (element) {
      //     const elementPosition = element.offsetTop - offset;
      //     window.scrollTo({
      //       top: elementPosition,
      //       behavior: 'smooth'
      //     });
      //   }
      // });
      const element = document.getElementById(elementId);
      if (element) {
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - 20; // 20px offset from top

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    },

    // Domain selection methods
    selectDomain(index) {
      this.selectedDomainIndex = index;
    },

    async proceedWithSelectedDomain() {
      if (this.selectedDomainIndex === null) {
        swal('Error', 'Please select a domain to continue.', 'error');
        return;
      }

      // Set the selected domain data
      this.domainData = this.multipleDomains[this.selectedDomainIndex];
      console.log('this.domainData', this.domainData)
      // Hide the modal
      $('#domainSelectionModal').modal('hide');
      this.showDomainSelectionModal = false;
      
      // Reset loading state and continue with audit
      this.loading = true;
      
      try {
        await this.continueWithDomainData();
      } catch (error) {
        console.error('Error continuing with selected domain:', error);
        swal('Error', 'Failed to continue with the selected domain. Please try again.', 'error');
      }
    },

    formatDate(dateString) {
      if (!dateString) return 'N/A';
      try {
        return moment(dateString).format('MMM DD, YYYY');
      } catch (e) {
        return 'Invalid Date';
      }
    },

    // Reset domain selection state
    resetDomainSelection() {
      this.multipleDomains = [];
      this.selectedDomainIndex = null;
      this.showDomainSelectionModal = false;
    },
  }
};
</script>

<style scoped>
.progress-bar {
  transition: width 0.6s ease;
}

.flex-column {
  display: flex;
  flex-direction: column;
}
#reportContent {
  background: #fff;
}

.bg-success {
  background-color: #08a14c !important;
}
.bg-warning {
  color: black !important;
  background-color: rgb(244 200 108) !important;
}
.badge.bg-warning {
  border: none;
}
.alert.alert-warning {
  color: black !important;
  border: none;
  background-color: rgb(244 200 108) !important;
}
.alert.alert-danger {
  color: black !important;
  border: none;
  background-color: rgb(244 200 108) !important;
}

.bg-danger {
  background-color: #dc3545 !important;
}
.circular-progress {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.circular-inner {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}

.score-text {
  font-size: 1rem;
  color: #343a40;
}
.text-dark-gray {
  color: #343a40;
}
body {
  background-color: #f8f9fa; /* Light background similar to the image */
  font-family: 'Poppins', sans-serif; /* Optional: Use Poppins for a similar font style */
}

.bg-light-blue {
  background-color: #f0f4f8; /* A light blue background for the header */
}

.card {
  border-radius: 10px; /* Rounded corners for the card */
}

.card-title {
  font-weight: 600; /* Slightly bolder card titles */
}


.fa { /* For Font Awesome icons */
  font-size: 1.2em; /* Adjust icon size */
}
.main-page {
  background-color: #f8f9fa;
  color: #212529;
}
.prose {
  color: #495057;
}
.prose p {
  margin-bottom: 1em;
}
ul {
  margin-left: 0 !important;
  list-style-type: none;
  padding-left: 0;
}
li {
  margin-top: 5px;
}
.prose ul {
  list-style-position: inside;
  padding-left: 0;
}
.prose li {
  margin-bottom: 0.5em;
}
.metric-circle {
  width: 110px;
  height: 110px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.display-5 {
  font-size: 2.2em;
}
.progress-circle {
  position: relative;
  width: 96px;
  height: 96px;
}
.progress-circle svg {
  width: 100%;
  height: 100%;
}
.progress-circle span {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  font-weight: bold;
}

.print-only .progress-circle {
  position: relative;
  width: 120px;
  height: 120px;
  display: inline-block;
}
.print-only .progress-circle svg {
  width: 100%;
  height: 100%;
  display: block;
}
.print-only .progress-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 1.2rem;
  font-weight: bold;
  color: #343a40;
  z-index: 10;
}
.card-section {
  width: 100%;
  background-color: white;
  border: 1px solid #dee2e6;
  //border-radius: 0.375rem;
  //box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}
.bg-opacity-10 { opacity: 0.5; }
.bg-success-10 { background-color: rgba(38, 250, 86, 0.5); }
.bg-warning-10 { background-color: rgba(255, 193, 7, 0.1); }
.bg-danger-10 { background-color: rgba(220, 53, 69, 0.1); }

.bg-yellow-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 249 195 / var(--tw-bg-opacity, 1));
}
.text-yellow-700 {
  --tw-text-opacity: 1;
  color: rgb(161 98 7 / var(--tw-text-opacity, 1));
}
.bg-blue-100 {
  --tw-bg-opacity: 1;
  background-color: rgba(7, 33, 147, 0.3);
}
.text-blue-700 {
  --tw-text-opacity: 1;
  color: rgb(7 33 147 / var(--tw-text-opacity, 1));
}
.bg-green-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1));
}
.text-green-700 {
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity, 1));
}
.bg-red-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(255, 0, 0, 0.3);
}
.text-red-700 {
  --tw-text-opacity: 1;
  color: rgb(204 0 0 / var(--tw-text-opacity, 1));
}

/* Standardized Report Styles */
/* Base text styles */
[class^="report-"] {
  color: #343a40;
  margin-bottom: 0.5rem;
}

/* Text sizes and weights */
.report-main-heading {
  font-size: 1.75rem;
  font-weight: bold;
  margin: 0;
}

.report-section-heading {
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 1rem;
}

.report-sub-heading {
  font-size: 1.25rem;
  font-weight: 500;
}

.report-text,
.report-text-small {
  color: #6c757d;
  font-weight: 500;
}

.report-text {
  font-size: 1rem;
}

.report-text-small {
  font-size: 0.75rem;
}

.print-only {
  display: none !important;
}
@media print {
  .no-print {
    display: none !important;
  }
  .print-only {
    display: block !important;
  }
  .pdf-break-before {
    margin-top: 45px;
    padding-top: 5px;
  }
}

.share-link-card {
  background: linear-gradient(90deg, #f5f8ff 0%, #eaf0fb 100%);
  border-radius: 1rem;
  box-shadow: 0 2px 12px rgba(31, 75, 241, 0.07);
}

.share-link-icon {
  width: 54px;
  height: 54px;
  background: #1f4bf1;
  color: #fff;
  border-radius: 50%;
  font-size: 1.7rem;
  box-shadow: 0 2px 8px rgba(31, 75, 241, 0.12);
}

.btn-brand.download-pdf-btn {
  background: linear-gradient(90deg, #1f4bf1 0%, #3b82f6 100%);
  color: #fff;
  border: none;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(31, 75, 241, 0.12);
  font-size: 0.8rem;
  transition: background 0.2s, box-shadow 0.2s;
  font-weight: 400;
}
.btn-brand.download-pdf-btn:hover, .btn-brand.download-pdf-btn:focus {
  background: linear-gradient(90deg, #3b82f6 0%, #1f4bf1 100%);
  color: #fff;
  box-shadow: 0 4px 16px rgba(31, 75, 241, 0.18);
}
.pdf-icon-wrapper {
  background: #fff;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  box-shadow: 0 2px 8px rgba(31, 75, 241, 0.10);
  margin-right: 10px;
}
.share-link-card {
  background: linear-gradient(90deg, #f5f8ff 0%, #eaf0fb 100%);
  border-radius: 1rem;
  box-shadow: 0 2px 12px rgba(31, 75, 241, 0.07);
  min-width: 260px;
}
.share-link-icon {
  width: 54px;
  height: 54px;
  background: #1f4bf1;
  color: #fff;
  border-radius: 50%;
  font-size: 1.7rem;
  box-shadow: 0 2px 8px rgba(31, 75, 241, 0.12);
}

/* Previous Reports List Styles */
.reports-list {
  border: 1px solid #e9ecef;
  border-radius: 0.375rem;
}

.report-item {
  transition: all 0.2s ease-in-out;
  cursor: pointer;
}

.report-item:hover {
  background-color: #f8f9fa;
  border-color: #1f4bf1 !important;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(31, 75, 241, 0.1);
}

.report-item:last-child {
  margin-bottom: 0 !important;
}

.cursor-pointer {
  cursor: pointer;
}

.gap-2 {
  gap: 0.5rem;
}

/* Tab Styles */
.nav-tabs .nav-link {
  border: none;
  border-bottom: 3px solid transparent;
  color: #6c757d;
  font-weight: 500;
  padding: 1rem 1.5rem;
  transition: all 0.2s ease-in-out;
}

.nav-tabs .nav-link:hover {
  border-color: transparent;
  color: #1f4bf1;
  background-color: rgba(31, 75, 241, 0.05);
}

.nav-tabs .nav-link.active {
  color: #1f4bf1;
  background-color: transparent;
  border-color: transparent transparent #1f4bf1 transparent;
  border-bottom: 3px solid #1f4bf1;
}

.nav-tabs .nav-link.active:hover {
  border-color: transparent transparent #1f4bf1 transparent;
}

.card-header-tabs {
  border-bottom: 1px solid #dee2e6;
  margin-bottom: 0;
}

.tab-content {
  animation: fadeIn 0.3s ease-in-out;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

/* Search Input Styles */
.input-group-text {
  background-color: #f8f9fa;
  border-color: #ced4da;
  color: #6c757d;
}

.input-group .form-control:focus {
  border-color: #1f4bf1;
  box-shadow: 0 0 0 0.2rem rgba(31, 75, 241, 0.25);
}

.input-group .form-control:focus + .input-group-append .btn {
  border-color: #1f4bf1;
}

/* Smooth scrolling enhancement */
html {
  scroll-behavior: smooth;
}

/* Add scroll margin to account for fixed headers */
#reportContent, #crux, #gtmetrix, #wpo {
  scroll-margin-top: 100px;
}

/* View More Details button hover effect */
.btn-light.border:hover {
  background-color: #1f4bf1;
  color: white;
  border-color: #1f4bf1;
  transform: translateY(-1px);
  transition: all 0.2s ease-in-out;
}

/* Domain Selection Modal Styles */
.domain-selection-list {
  max-height: 400px;
  overflow-y: auto;
}

.domain-option {
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  border: 2px solid #e9ecef;
}

.domain-option:hover {
  border-color: #1f4bf1;
  background-color: #f8f9fa;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(31, 75, 241, 0.1);
}

.domain-option.selected {
  border-color: #1f4bf1;
  background-color: #f5f8ff;
  box-shadow: 0 2px 8px rgba(31, 75, 241, 0.15);
}

.domain-option .card-body {
  padding: 1rem;
}

.domain-option h6 {
  color: #1f4bf1;
  font-weight: 600;
}

.domain-option .text-muted {
  font-size: 0.875rem;
}

.domain-option .badge {
  font-size: 0.75rem;
}
</style>
